import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRouteCancel = '/operation-auxiliary/cancellation';

@Injectable({
  providedIn: 'root'
})
export class SaleNoteCancelDocumentService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRouteCancel);
  }
}
